/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { RecordEntry } from '../model/recordEntry';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class FilesApi extends BaseApi {
    declareRecord(fileId, opts) {
        throwIfNotDefined(fileId, 'fileId');
        const pathParams = {
            fileId
        };
        const queryParams = {
            hideRecord: opts === null || opts === void 0 ? void 0 : opts.hideRecord,
            parentId: opts === null || opts === void 0 ? void 0 : opts.parentId,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/files/{fileId}/declare',
            pathParams,
            queryParams,
            returnType: RecordEntry
        });
    }
}
